
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { FeeTypeResponse } from "../../models/dtos";

export const feeTypesApi = createApi({
  reducerPath: 'feeTypesApi',
  baseQuery: baseAuthQuery('FeeTypes'),
  tagTypes: ['FeeType'],
  endpoints: (builder) => ({
    getFeeTypes: builder.query<ApiResponse<FeeTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['FeeType'],
    }),
    getFeeTypeById: builder.query<ApiResponse<FeeTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['FeeType'],
    }),
    updateFeeType: builder.mutation<ApiResponse<FeeTypeResponse>, Partial<FeeTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['FeeType'],
    }),
    deleteFeeType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['FeeType'],
    }),
  }),
});
